import styled from 'styled-components';
import { Image } from '../../../shared';
import { Breakpoints, Shadows } from '../../../themes';

export const GridViewContainer = styled.div`
  height: 100%;
`;

export const GridViewContent = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`;

export const GridViewInfoContainer = styled.div`
  flex-grow: 1;
  min-width: 0;

  height: calc(100% - 2.5rem);
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const GridViewImageContainer = styled.div`
  flex-shrink: 0;
  width: 7.875rem;
  height: calc(100% - 1.5rem);
  padding: 0.75rem;
`;

export const ListViewContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: ${Breakpoints.smallWidth}) {
    max-width: calc(100vw - 4rem);
  }
`;

export const ListViewFolderIcon = styled(Image)`
  width: 2.5rem;
  height: 2.5rem;
`;

export const ListViewContent = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;
  overflow: hidden;
`;

export const FolderDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.125rem;
  align-items: center;
  overflow: hidden;
`;

export const DraggableCardGrid = styled.div`
  position: relative;
  height: 6.25rem;
  background: ${(props) => {
    if (props.hovered && !props.selected) {
      if (props.canDrop) {
        return props.theme.colors.greenLight;
      }
      return props.theme.colors.redDefault;
    }
    return props.theme.colors.elevatedBackgroundPrimary;
  }};
  ${(props) => (props.selected ? Shadows.d0 : Shadows.d1)};
  border: 1px solid transparent;
  border-radius: 0.25rem;
  align-items: center;
  cursor: pointer;
  transition: border-color 0.75s;
  border-color: ${(props) =>
    props.selected ? props.theme.colors.greenDefault : 'transparent'};
  box-sizing: border-box;
  opacity: ${(props) => (props.opacity ? props.opacity : 1)};
  &:hover {
    border-color: ${(props) =>
      props.selected
        ? props.theme.colors.greenDefault
        : props.theme.colors.greenLight};
  }
`;

export const DraggableCardList = styled.div`
  text-align: left;
  padding: 0.5rem 0.75rem;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => {
    if (props.hovered && !props.selected) {
      if (props.canDrop) {
        return props.theme.colors.greenLight;
      }
      return props.theme.colors.redDefault;
    }
    return props.theme.colors.elevatedBackgroundPrimary;
  }};
  ${(props) => (props.selected ? Shadows.d0 : Shadows.d1)};
  border: 1px solid transparent;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: border-color 0.075s;
  border-color: ${(props) =>
    props.selected ? props.theme.colors.greenDefault : 'transparent'};
  box-sizing: border-box;
  opacity: ${(props) => (props.opacity ? props.opacity : 1)};

  &:hover {
    border-color: ${(props) =>
      props.selected
        ? props.theme.colors.greenDefault
        : props.theme.colors.greenLight};
  }
`;
